import {FC} from "react";
import { toast } from "react-toastify";
import useDrawer from "../../../hooks/useDrawer";
import {Contentbar} from "../../../ui/Sidebar";
import {useDeleteCategoryMutation} from "./__generated__/CategoryDelete.mutation.generated";


const CategoryDelete:FC = () => {
  const { id, closeChildrenHandler, closeRootHandler } = useDrawer();

  const [deleteHandler, { loading }] = useDeleteCategoryMutation({
    variables: { id },
    onCompleted: () => {
      toast.success('Удаление выполнено!');
      closeRootHandler();
      closeChildrenHandler();
    },
    onError: () => {
      toast.error('При удалении произошла ошибка');
    }
  });

  return (
    <Contentbar isLoading={loading} onClose={closeChildrenHandler} onSubmit={deleteHandler}>
      <h2>Вы точно уверены?</h2>
      <p><b>Внимание!</b> Удаление происиходит безвовратно, удаленые данные восстановлению не подлежать.</p>
      <p>Для продолжения нажмите кнопку <b>"Подтвердить".</b></p>
    </Contentbar>
  )
}

export default CategoryDelete;
